import React, { useState, ChangeEvent, useEffect } from 'react';

interface TextInputProps {
    placeholder?: string;
    value?: string;
    additionalClass?: string;
    disabled?: boolean;
    onValueChange?: (value: string) => void;
    idPrefix?: string;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onBlur?: (value: string) => void;
    isNumeric?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({ placeholder, value, additionalClass, disabled, onValueChange, idPrefix, onKeyDown, onBlur, isNumeric }) => {
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;

        setInputValue(newValue);

        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    const handleBlur = () => {
        if (onBlur) {
            onBlur(inputValue);
        }
    };

    return (
        <input
            id={`${idPrefix ? `${idPrefix}-` : ""}text-input`}
            type={isNumeric ? "number" : "text"}
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleBlur}
            className={`form-control ${additionalClass ?? ""}`}
            placeholder={placeholder}
            disabled={disabled}
            onKeyDown={e => onKeyDown && onKeyDown(e)}
        />
    );
};

export default TextInput;
